exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tax-filing-advantages-icon{background-color:rgba(223,216,239,.5)}.tax-filing-advantages-icon__finity{background-color:#fafcff}.tax-filing-advantages{padding-bottom:30%}.tax-filing-advantages-divider{height:8px;width:1px;background:var(--primaryVariant4);position:relative;top:52px}", ""]);

// exports
